import { render, staticRenderFns } from "./JBProposalSendings.vue?vue&type=template&id=fad4fa90"
import script from "./JBProposalSendings.vue?vue&type=script&lang=js"
export * from "./JBProposalSendings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports